import React from 'react'
import { colors } from '@fs/zion-ui'

export default function MenuMore({ selected = false, fillColor = colors.blue80 }) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_13187_56724"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13187_56724)">
        <path
          d="M4 17.2692V16.2692H20V17.2692H4ZM4 12.5V11.5H20V12.5H4ZM4 7.73077V6.73077H20V7.73077H4Z"
          fill={selected ? fillColor : colors.gray100}
          fillOpacity={selected ? 1 : 0.5}
        />
      </g>
    </svg>
  )
}
